import React from 'react';
import moment from 'moment';

import EditScheduleForm from '../forms/EditScheduleForm';

// not a real modal
class ModalCalendar extends React.Component {

    constructor(props) {
        super(props);
    }

    render () {
        const dates = this.props.dates;
        const onChange = this.props.onChange || null;
        if (typeof dates == typeof undefined || dates == 'undefined') {
            return null;
        }
        return (
            <div className="calendar-modal" >
                <form noValidate>
                    <EditScheduleForm disableBefore={moment()} onChange={onChange} initialFormData={{dates}} errors={{}} ref="form" />
                </form>
            </div>
        );
    }
}

export default ModalCalendar;



/** WEBPACK FOOTER **
 ** ./app/src/components/ModalCalendar.js
 **/